"use client";

import dynamic from "next/dynamic";

const BuyBox = dynamic(() => import("./BuyBox").then((mod) => mod.BuyBox));

export { BuyBox };
